module.exports = __webpack_public_path__ + "static/media/rectangle-dsktp-logged-in.89e32472.png";